export default __webpack_public_path__ + "static/media/verticalDots.5e9cd305.svg";